import React from 'react';
import style from "./index.module.css";
import {Breadcrumb, Divider} from "antd";
import CertificateNavModule from "../../components/certificateNavModule";


const EighthPage = () => {
    const baseItem = [
        {
            title: <div>首页</div>,
        },
        {
            title: "联系我们",
        },
    ];

    return (
        <div className={style.pageContainer}>
            <Breadcrumb
                items={baseItem}
            />

            <div className={style.content}>
                <div className={style.leftNavBar}>
                    <CertificateNavModule/>
                </div>

                <div className={style.rightMainContainer}>
                    <div>
                        <div className={style.pageTitle}>联系我们</div>
                        <Divider style={{padding: '0 30px', borderColor: '#043554'}}>CONTACT US</Divider>
                    </div>


                    <div style={{color:'#666666'}}>
                        <div className={style.companyName}>湖州市两山生态资源认证有限公司</div>
                        <p>
                            【地址】：浙江省湖州市西塞山路1558号联科商务中心1幢E区612
                        </p>
                        <p>
                            【邮编】：313000
                        </p>
                        <p>
                            【电话】：18767235063
                        </p>
                        <p>
                            【电子邮箱】：lsst_strzsyb@163.com
                        </p>
                    </div>

                </div>
            </div>

        </div>

    );
};

export default EighthPage;